var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg360Degree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1835 6.53285C20.5004 6.83255 20.5 6.99098 20.5 7C20.5 7.00902 20.5004 7.16745 20.1835 7.46715C19.8611 7.77199 19.3142 8.11562 18.514 8.43571C16.9218 9.07257 14.6194 9.5 12 9.5C9.38055 9.5 7.07816 9.07257 5.48602 8.43571C4.68579 8.11562 4.13885 7.77199 3.81651 7.46715C3.49961 7.16745 3.49998 7.00885 3.5 6.99983C3.49998 6.99081 3.49961 6.83255 3.81651 6.53285C4.13885 6.22801 4.68579 5.88438 5.48602 5.56429C7.07816 4.92743 9.38055 4.5 12 4.5C14.6194 4.5 16.9218 4.92743 18.514 5.56429C19.3142 5.88438 19.8611 6.22801 20.1835 6.53285Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11C17.5228 11 22 9.20914 22 7V17C22 19.2091 17.5228 21 12 21C6.47715 21 2 19.2091 2 17V7C2 9.20914 6.47715 11 12 11ZM17.5 15C18.3284 15 19 14.3284 19 13.5C19 12.6716 18.3284 12 17.5 12C16.6716 12 16 12.6716 16 13.5C16 14.3284 16.6716 15 17.5 15ZM3.81651 17.4671C4.13885 17.7719 4.68578 18.1155 5.48601 18.4356C7.07816 19.0725 9.38055 19.4999 12 19.4999C14.0755 19.4999 15.952 19.2316 17.4338 18.8033L13.7059 14.7648C13.3207 14.3474 12.6656 14.3343 12.264 14.736L11 16L8.7587 13.0116C8.37143 12.4952 7.60369 12.4756 7.19048 12.9714L3.6218 17.2538C3.66745 17.3143 3.73022 17.3855 3.81651 17.4671Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg360Degree);
export default __webpack_public_path__ + "static/media/360-degree.3c83736f62b5e111411748e1ac61652f.svg";
export { ForwardRef as ReactComponent };